import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type NotificationPreferenceInput = {
  categoryKey: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type PartnerUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  partnerIdentifier: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  regionIdentifier?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type ReferralState =
  | 'LEAD_DENIED'
  | 'LEAD_QUALIFIED'
  | 'LEAD_SELLER_FLOW_INCOMPLETE'
  | 'OFFER_ACCEPTED'
  | 'OFFER_ASSESSMENTS_COMPLETED'
  | 'OFFER_CLOSED'
  | 'OFFER_CONTINGENCIES_RELEASED'
  | 'OFFER_EXPIRED'
  | 'OFFER_EXPIRING_SOON'
  | 'OFFER_FINAL_OFFER_UNRELEASED'
  | 'OFFER_IN_CONTRACT'
  | 'OFFER_SENT'
  | 'OFFER_VIEWED'
  | 'OFFER_WITHDRAWN'
  | 'UNKNOWN';

export type RefreshOfferInput = {
  sellerInputId: Scalars['String']['input'];
};

export type SearchReferralsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<ReferralState>;
};

export type SlackChannel =
  | 'SIGN_UP';

export type SlackMessageField = {
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TourRequestState =
  | 'CANCELED'
  | 'COMPLETE'
  | 'NO_SHOW'
  | 'REQUESTED'
  | 'SCHEDULED';

export type UpdateUserNotificationPreferencesInput = {
  notificationPreferences: Array<NotificationPreferenceInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateEmailQuery_validateEmail_ValidateEmailResponse = { __typename?: 'ValidateEmailResponse', isValid: boolean, normalizedEmail: string };

export type ValidateEmailQuery_Query = { __typename?: 'Query', validateEmail: ValidateEmailQuery_validateEmail_ValidateEmailResponse };


export type ValidateEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ValidateEmailQuery = ValidateEmailQuery_Query;


export const ValidateEmailDocument = gql`
    query ValidateEmail($email: String!) {
  validateEmail(email: $email) {
    isValid
    normalizedEmail
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ValidateEmail(variables: ValidateEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ValidateEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidateEmailQuery>({ document: ValidateEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ValidateEmail', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;